import posthog from "posthog-js";

// Always export the posthog instance
export { posthog };
export default posthog;

const posthogDebug = import.meta.env.VITE_PUBLIC_POSTHOG_DEBUG === "true";

// Initialize only in browser environment
if (typeof window !== "undefined") {
  const posthogKey =
    import.meta.env.VITE_PUBLIC_POSTHOG_KEY || process.env.POSTHOG_KEY;
  const posthogHost =
    import.meta.env.VITE_PUBLIC_POSTHOG_HOST ||
    process.env.POSTHOG_HOST ||
    "https://us.i.posthog.com";

  if (posthogDebug) {
    console.log(
      "[PostHog] Initializing with key:",
      posthogKey ? `${posthogKey.substring(0, 10)}...` : "Key missing"
    );
    console.log("[PostHog] API host:", posthogHost);
  }

  if (!posthogKey) {
    console.error("[PostHog] ERROR: No API key found!");
  } else {
    posthog.init(posthogKey, {
      api_host: posthogHost,
      capture_pageview: false, // We're handling this manually
      person_profiles: "identified_only",
      loaded: (ph) => {
        if (posthogDebug) {
          console.log("[PostHog] ✅ Loaded successfully");
          console.log("[PostHog] Session ID:", ph.get_session_id());
          console.log("[PostHog] Distinct ID:", ph.get_distinct_id());
        }
      },
      // Enable debug mode to see network requests
      debug: false,
    });

    if (posthogDebug) {
      console.log("[PostHog] Initialized successfully");
    }

    // Respect Do Not Track
    // if (navigator.doNotTrack === "1") {
    //   console.log("[PostHog] Do Not Track enabled - opting out");
    //   posthog.opt_out_capturing();
    // }
  }
}
